import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import Loading from "components/Loading";
import { TreeSelect } from "antd";
import useCallApi from "hook/useCallApi";
import { getDropShipping, getDropShippingCategory } from "actions/dropshippingActions";

const limit = 20;

const DropShippingList = ({ getDropShipping, getDropShippingCategory }) => {
    const [page, setPage] = useState(0);
    const [filter, setFilter] = useState({});
    const params = useMemo(() => ({ limit, offset: page * limit, ...filter, source: "1" }), [page, filter]);
    const { data, loading: isLoading } = useCallApi(getDropShipping, params);
    const { data: categories } = useCallApi(getDropShippingCategory);
    const cateShow = useMemo(() => {
        if (!categories?.items) return [];

        function transformCategoriesWithChildren(c) {
            return c.map((item) => ({
                value: item.category_id,
                title: item.name,
                children:
                    item.children && item.children.length > 0 ? transformCategoriesWithChildren(item.children) : [],
            }));
        }

        return transformCategoriesWithChildren(categories.items);
    }, [categories]);

    const { t } = useTranslation();

    return (
        <div className="card mb-5 mb-xl-10 container">
            <div className="d-flex gap-4 mt-8" style={{ minHeight: "40px" }}>
                <div className="col-md-4">
                    <TreeSelect
                        showSearch
                        style={{ width: "100%" }}
                        treeNodeFilterProp="label"
                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                        className="h-100"
                        placeholder="Please select category"
                        treeDefaultExpandAll
                        onChange={(cate) => {
                            console.log(cate);
                        }}
                        treeData={cateShow}
                    />
                </div>
            </div>
            <div className="row mt-10">
                {(data?.items || []).map((product, index) => (
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={product.product_idt}>
                        <div className="card h-100 shadow-sm border rounded">
                            <div className="w-100" style={{ height: "180px", overflow: "hidden" }}>
                                <img
                                    src={product?.images?.[0]?.image_url}
                                    alt={product?.title}
                                    className="w-100 h-100 mt-2"
                                    style={{ objectFit: "contain" }}
                                />
                            </div>

                            <div className="card-body d-flex flex-column justify-content-between">
                                <div>
                                    <h5 className="text-danger fw-bold mb-1 d-flex justify-content-between">
                                        <span>{product?.price} </span>
                                    </h5>
                                    <h6 className="text-truncate">{product?.title}</h6>
                                    <p className="text-muted mb-1 small">ID: {product?.product_id}</p>
                                    <p className="text-info mb-1 small">Category: {product?.category_name}</p>
                                    <p className="text-primary mb-0 small">
                                        Inventory: {product?.warehouse}{" "}
                                        <span
                                            className="text-danger"
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content={t("Total Stock")}
                                        >
                                            ({product?.stock_quantity})
                                        </span>
                                    </p>
                                </div>

                                <div className="d-flex gap-2 mt-3">
                                    <button className="btn btn-primary flex-1 flex-grow-1 flex-shrink-1">
                                        Save Base
                                    </button>
                                    <button className="btn btn-info flex-1 flex-grow-1 flex-shrink-1">Detail</button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="ag-theme-alpine">
                <div className="al-form-input-date mb-5 ag-grid-paginate-custom">
                    <ReactPaginate
                        breakLabel="..."
                        onPageChange={(page) => {
                            setPage(page?.selected || 0);
                        }}
                        pageRangeDisplayed={2}
                        pageCount={data?.total ? Math.ceil(data?.total / limit) : 1 || 0}
                        marginPagesDisplayed={1}
                        renderOnZeroPageCount={null}
                        forcePage={page}
                        nextLabel={
                            <div
                                className="ag-button ag-paging-button mt-1"
                                role="button"
                                aria-label="Next Page"
                                tabIndex={0}
                                aria-disabled="true"
                            >
                                <span className="ag-icon ag-icon-next" unselectable="on" role="presentation" />
                            </div>
                        }
                        previousLabel={
                            <div
                                className="ag-button ag-paging-button mt-1"
                                role="button"
                                aria-label="Previous Page"
                                tabIndex={0}
                                aria-disabled="true"
                            >
                                <span className="ag-icon ag-icon-previous" unselectable="on" role="presentation" />
                            </div>
                        }
                    />
                </div>
            </div>
            <Loading isLoading={isLoading} />
        </div>
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    getDropShipping,
    getDropShippingCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(DropShippingList);
